export const IDLE = 'IDLE';
export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const defaultStatuses = ['IDLE', 'PENDING', 'SUCCESS', 'ERROR'];

export const apiStatus = {
  IDLE,
  PENDING,
  SUCCESS,
  ERROR,
};
